import View from '../../../../../components/configPdf/View'
import Text3 from '../../../../../components/configPdf/Text3'

// Columnas: DETALLE/DESCRIPCIÓN | SALDO ANTERIOR | SÚPER NUEVOS | NUEVO | SEMI-NUEVOS | USADOS |
// MARCADOS | TOTAL | OBSERVACIONES — igual que la boleta física real de la empresa. Filas no
// retornables dejan las 5 columnas de estado en blanco (un producto envasado no tiene "estado físico").
const COL_WIDTHS = {
  detalle: '22%',
  saldoAnterior: '9%',
  estado: '8%',
  total: '9%',
  obs: '20%',
}

const ESTADOS = [
  { key: 'superNuevo', label: 'SÚPER NUEVOS' },
  { key: 'nuevo', label: 'NUEVO' },
  { key: 'semiNuevo', label: 'SEMI - NUEVOS' },
  { key: 'usado', label: 'USADOS' },
  { key: 'marcado', label: 'MARCADOS' },
]

const NotaProductoPdfTable = ({ productos = [] }) => {
  return (
    <View flexDirection='column' width='100%'>
      <View width='100%'>
        <View width={COL_WIDTHS.detalle} border={{ left: true, top: true, right: true, bottom: true }} justifyContent='center' style={{ backgroundColor: '#e3e4fc' }}>
          <Text3 bold>DETALLE / DESCRIPCIÓN</Text3>
        </View>
        <View width={COL_WIDTHS.saldoAnterior} border={{ top: true, right: true, bottom: true }} justifyContent='center' style={{ backgroundColor: '#e3e4fc' }}>
          <Text3 bold>SALDO ANTERIOR</Text3>
        </View>
        {ESTADOS.map((e) => (
          <View key={e.key} width={COL_WIDTHS.estado} border={{ top: true, right: true, bottom: true }} justifyContent='center' style={{ backgroundColor: '#ffe7cc' }}>
            <Text3 bold>{e.label}</Text3>
          </View>
        ))}
        <View width={COL_WIDTHS.total} border={{ top: true, right: true, bottom: true }} justifyContent='center' style={{ backgroundColor: '#a4e9fc' }}>
          <Text3 bold>TOTAL</Text3>
        </View>
        <View width={COL_WIDTHS.obs} border={{ top: true, right: true, bottom: true }} justifyContent='center'>
          <Text3 bold>OBSERVACIONES</Text3>
        </View>
      </View>

      {productos.length === 0 ? (
        <View width='100%'>
          <View width='100%' border={{ left: true, right: true, bottom: true }} justifyContent='center'>
            <Text3>Sin movimientos ese día</Text3>
          </View>
        </View>
      ) : (
        productos.map((p) => (
          <View key={p.producto_id} width='100%'>
            <View width={COL_WIDTHS.detalle} border={{ left: true, right: true, bottom: true }} justifyContent='center' alignItems='flex-start'>
              <Text3 style={{ textAlign: 'left' }}>
                {p.nombre}
              </Text3>
            </View>
            <View width={COL_WIDTHS.saldoAnterior} border={{ right: true, bottom: true }} justifyContent='center'>
              <Text3>{p.saldoAnterior ?? 0}</Text3>
            </View>
            {ESTADOS.map((e) => (
              <View key={e.key} width={COL_WIDTHS.estado} border={{ right: true, bottom: true }} justifyContent='center'>
                <Text3>{p.retornable ? (p.estados?.[e.key] || '') : ''}</Text3>
              </View>
            ))}
            <View width={COL_WIDTHS.total} border={{ right: true, bottom: true }} justifyContent='center' style={{ backgroundColor: '#f5f9ff' }}>
              <Text3 bold>{(p.saldoAnterior || 0) + (p.total || 0)}</Text3>
            </View>
            <View width={COL_WIDTHS.obs} border={{ right: true, bottom: true }} justifyContent='center'>
              <Text3>{p.obs || ''}</Text3>
            </View>
          </View>
        ))
      )}
    </View>
  )
}

export default NotaProductoPdfTable
